 !(function () {
    const viewport = document.querySelector('meta[name="viewport"]');
    function switchViewport() {
      const value =
        window.outerWidth > 360
          ? 'width=device-width,initial-scale=1'
          : 'width=360';
      if (viewport.getAttribute('content') !== value) {
        viewport.setAttribute('content', value);
      }
    }
    addEventListener('resize', switchViewport, false);
    switchViewport();
  })();

  function openModal(class_name) {
    const modal = document.querySelector(class_name);
    if(modal != null) {
      modal.classList.add('modal-open');
      document.body.classList.add('no-scorll');
    }
  }

  function modalClose() {
    const is_open = document.querySelectorAll('.modal-open');
    if(document.body.classList.contains('no-scroll')) {
      document.body.classList.remove('no-scorll');
    }
    if(is_open != null) {
      is_open.forEach((elm)=>{
        elm.classList.remove('modal-open');
      });
    }
  }

  function startMovie(class_name) {
    const movie = document.querySelector(class_name);
    if(movie != null) {
      movie.play();
    }
  }
  
  function stopMovie(class_name) {
    const movie = document.querySelector(class_name);
    if(movie != null) {
      movie.pause();
    }
  }

  function openSizechart(target) {
    let scrollbarWidth = window.innerWidth - document.body.clientWidth;
    document.body.style.paddingRight = `${scrollbarWidth}px`;
    const modalBG = document.createElement('div');
    modalBG.classList.add('sizechart-bg');
    const targetModal = document.querySelector(`.${target}`);
    document.body.appendChild(targetModal);
    document.body.appendChild(modalBG);
    const closeBtn = targetModal.querySelector(`.js-sizechart-close`);
    targetModal.classList.add('sizechart-open');
    modalBG.setAttribute('onclick', 'closeSizechart()');
    if(closeBtn != null) {
      closeBtn.addEventListener('click', ()=>{
        targetModal.classList.remove('sizechart-open');
      });
    }
  }
  
  function closeSizechart() {
    const activeModal = document.querySelector('.sizechart-open');
    const activeBG = document.querySelector('.sizechart-bg');
    if(activeModal != null) {
      activeModal.classList.remove('sizechart-open');
    }
    if(activeBG != null) {
      activeBG.parentNode.removeChild(activeBG);
    }
    document.body.style.paddingRight = `0px`;
  }
  
// smooth scroll

window.addEventListener('DOMContentLoaded', ()=>{
  if(window.innerWidth > 768) {
    let now_position = window.pageYOffset;
    let first_position = 0;
    setTimeout(()=>{
      now_position = window.pageYOffset;
    }, 2500);
    window.addEventListener('scroll', ()=>{
      const followers = document.querySelectorAll('.js-smooth-follow');
      if(followers != null) {
        const scrollY = window.scrollY;
        const dist = now_position - scrollY;
        if(dist > 0) {
          followers.forEach((elm)=>{
            first_position = first_position + 1;
            elm.style.transform = `translateY(${first_position / 15}px)`;
          });
        } else {
        followers.forEach((elm)=>{
          first_position = first_position - 1;
          elm.style.transform = `translateY(${first_position / 15}px)`;
        });
        }
        now_position = window.pageYOffset;
      }
    });
  }
});

// smooth scroll

// switch color

window.addEventListener('DOMContentLoaded', ()=>{
  const color_swatches = document.querySelectorAll('.is-color-swatch');
  const color_name = document.querySelector('.js-color-name');
  if(color_swatches != null && color_name != null) {
    color_swatches.forEach((btn)=>{
      btn.addEventListener('click', ()=>{
        color_name.textContent = btn.previousElementSibling.value;
      });
    });
  }
});

// switch color

// loading

window.addEventListener('DOMContentLoaded', ()=>{
  const loading = document.querySelector('.js-loading');
  setTimeout(()=>{
    loading.classList.add('hide');
  }, 1500);
});

// loading
